export type PremiumContentEnumKeys = keyof typeof premiumContentEnum;

export const premiumContentEnum = {
  replay: {
    mediaType: "video",
    mediaName: "replay.mp4",
    titleKey: "feature.replay.title",
    descriptionKey: "feature.replay.description"
  },
  hd: {
    mediaType: "image",
    mediaName: "video_hd.png",
    titleKey: "feature.hdVideo.title",
    descriptionKey: "feature.hdVideo.description"
  },
  face: {
    mediaType: "video",
    mediaName: "twoWay.mp4",
    titleKey: "feature.face.title",
    descriptionKey: "feature.face.description"
  },
  more_cameras: {
    mediaType: "image",
    mediaName: "more_cameras.png",
    titleKey: "feature.moreCamera.title",
    descriptionKey: "feature.moreCamera.description"
  },
  noise: {
    mediaType: "video",
    mediaName: "noise.mp4",
    titleKey: "feature.noise.title",
    descriptionKey: "feature.noise.description"
  },
  download: {
    mediaType: "video",
    mediaName: "download.mp4",
    titleKey: "feature.download.title",
    descriptionKey: "feature.download.description"
  },
  watermark: {
    mediaType: "video",
    mediaName: "watermark.mp4",
    titleKey: "feature.watermark.title",
    descriptionKey: "feature.watermark.description"
  },
  detection_zones: {
    mediaType: "video",
    mediaName: "motionZone.mp4",
    titleKey: "feature.detectionZone.title",
    descriptionKey: "feature.detectionZone.description"
  },
  record: {
    mediaType: "video",
    mediaName: "manualVideo.mp4",
    titleKey: "feature.manualVideo.title",
    descriptionKey: "feature.manualVideo.description"
  }
} as const;
